import { csx, keyframes } from '@vtex/admin-ui'

const bagAnimation = keyframes({
  '0%': { opacity: 0, flexBasis: 0 },
  '50%': { opacity: 0, flexBasis: '20%', scale: 0.25 },
  '100%': { opacity: 100, scale: 1 },
})

const rotatePriceTag = keyframes({
  '0%': { opacity: 0 },
  '30%': { transform: 'rotate(-30deg)', opacity: 0 },
  '100%': { transform: 'rotate(0deg)', opacity: 1 },
})

const fillBackground = keyframes({
  from: {
    clipPath: 'circle(0% at 50% 50%)',
  },
  to: { clipPath: 'circle(150% at 50% 50%)' },
})

const styles = {
  container: csx({
    display: 'flex',
    flexDirection: 'column',
    rowGap: '$space-8',
    marginY: '$space-6',
  }),

  bagsContainer: csx({
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    rowGap: '$space-6',
    justifyContent: 'center',
    ':empty': { display: 'none' },
    '[hidden]': { display: 'none' },

    '.bag': {
      flexBasis: '20%',
      animation: `${bagAnimation} 0.5s ease`,
      '.shadow': { fill: '#545454', transition: 'fill 0.5s ease-out' },
      '.cover': {
        fill: 'transparent',
        transition: 'fill 0.5s ease',
        '&.background': { fill: '#DDDDDD' },
      },

      '.priceTag': { visibility: 'hidden' },

      '&.highlighted': {
        '.shadow': { fill: '#093F46' },
        '.cover.animation': {
          fill: '#D5EFF4',
          clipPath: 'circle(0% at 50% 50%)',
          animation: `${fillBackground} 0.5s forwards ease-out`,
        },
        '.priceTag': {
          visibility: 'visible',
          animation: `${rotatePriceTag} 0.5s ease-out`,
          transformOrigin: 'top',
          transformBox: 'content-box',
        },
      },
    },

    '.moreItemsTag': {
      '[hidden]': { display: 'none' },
      transition: 'opacity 2s ease-out',
      position: 'absolute',
      background: '$gray10',
      bottom: '-0.75rem',
      right: 0,
      borderRadius: '1rem',
      paddingX: '$space-2',
      paddingY: 1,
      border: '4px solid $white',
      color: '$primary',
    },
  }),

  description: csx({
    display: 'block',
  }),

  quantityInput: csx({
    display: 'inline-flex',
    marginX: '$space-2',
    input: { fieldSizing: 'content' },
    'span[role="alert"]': { maxWidth: '10rem' },
  }),
  tag: csx({ marginX: '$space-2' }),
}

export default styles
